
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/novosti/[slug]",
      function () {
        return require("private-next-pages/novosti/[slug]/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/novosti/[slug]"])
      });
    }
  